import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation"]

  generate(event) {
    event.preventDefault()

    const password = this.generateSecurePassword()
    this.passwordTarget.value = password
    this.confirmationTarget.value = password

    // Flash the fields to indicate they've been updated
    this.flashField(this.passwordTarget)
    this.flashField(this.confirmationTarget)
  }

  generateSecurePassword() {
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    const lowercase = "abcdefghijklmnopqrstuvwxyz"
    const numbers = "0123456789"
    const special = "!@#$%^&*"

    const allChars = uppercase + lowercase + numbers + special
    const length = 16

    let password = ""

    // Ensure at least one character from each category
    password += this.randomChar(uppercase)
    password += this.randomChar(lowercase)
    password += this.randomChar(numbers)
    password += this.randomChar(special)

    // Fill the rest randomly
    for (let i = password.length; i < length; i++) {
      password += this.randomChar(allChars)
    }

    // Shuffle the password
    return password.split('').sort(() => Math.random() - 0.5).join('')
  }

  randomChar(charset) {
    return charset[Math.floor(Math.random() * charset.length)]
  }

  flashField(field) {
    field.classList.add("ring-2", "ring-emerald-400")
    setTimeout(() => {
      field.classList.remove("ring-2", "ring-emerald-400")
    }, 500)
  }
}
